export default "__VITE_ASSET__BLziwQX6__"